import React, { Component } from 'react';
import styled, { keyframes, withTheme } from 'styled-components';
import em from 'polished/lib/helpers/em';

function tickerBuilder() {
  return keyframes`
    0% {
      transform: translate3d(0, 0, 0);
      visibility: visible;
    }
    50% {
      transform: translate3d(-10000px, 0, 0);
    }
    100% {
      transform: translate3d(0, 0, 0);
    }`;
}

const Wrapper = styled.div`
  width: 100%;
  height: 6.6em;
  transform: rotate(${props => props.rotation}deg);
  transform-origin: top right;
`;

const AnimationWrapper = styled.div`
  &.animate {
    animation: ${() => tickerBuilder()} 480s linear infinite;
  }
`;

const Text = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  white-space: nowrap;
  display: block;
  font-family: Flow-Poster-Bold, sans-serif !important;
  font-size: 2.8em;
  line-height: ${em(6.6, 2.8)};
  color: ${props => props.color ? props.color : props.theme.highlightColor};
`;

interface Props {
  color?: string;
  rotation?: number;
  animate?: boolean;
  index?: number;
  theme?: any;
}

class FlowStripe extends Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  render() {
    const {
      color,
      rotation,
      animate,
      theme: {
        isMobile
      }
    } = this.props;

    return (
      <Wrapper rotation={rotation || 0}>
        <AnimationWrapper className={animate && !isMobile ? 'animate' : ''}>
          <Text color={color}>
            ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL ⟚✹ #FLOWFESTIVAL ❂⩶ ❇✧ #FLOWFESTIVAL
          </Text>
        </AnimationWrapper>

      </Wrapper>
    )
  }
}

export default withTheme(FlowStripe);



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/ticker/FlowStripe.tsx